import Title from '@/components/InspectionReport/Items/Questions/Title';

export default {
    functional: true,
    props: {
        item: {
            type: Object,
            required: true,
        },
        resource: {
            type: Object,
            default: null,
        },
    },
    render(h, {
        props, data, _v, parent,
    }) {
        return h(
            'div',
            data,
            [
                h(Title, {}, props.item.title),
                _v(props.item.response === true ? parent.$t('True') : parent.$t('False')),
            ],
        );
    },
};
